import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {z as zod} from "zod";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/oauth-callback/4928d306-bc11-4c48-8ad4-7b6a32f0e737",
)({
    validateSearch: zod.object({
        connectionAttemptId: uuidZodValidator,
    }),
    beforeLoad: ({search}) => {
        return {
            connectionAttemptId: search.connectionAttemptId,
        };
    },
    loader: ({context}) => {
        const flipkartClientIdResult = zod.string().safeParse(import.meta.env.FLIPKART_CLIENT_ID);
        if (!flipkartClientIdResult.success) {
            throw new Error("Invalid Flipkart Client ID");
        }
        return {
            websiteAccessToken: context.authenticationStatus.accessToken,
            intellsysBaseUrl: context.intellsysBaseUrl,
            flipkartClientId: flipkartClientIdResult.data,
            connectionAttemptId: context.connectionAttemptId,
            connectionAttemptClient: context.connectionAttemptClient,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
